import "./city-card.scss";

const CityCard = ({ imgSrc, cardText }) => {
  return (
    <div className="city-card">
      <div className="city-text">{cardText}</div>
      <div class="round">
        <input type="checkbox" id="checkbox" />
        <label for="checkbox"></label>
      </div>
    </div>
  );
};

export default CityCard;
